const LOAD_LOCALE = 'intl/LOAD_LOCALE';
const SET_LOCALE_MESSAGES = 'intl/SET_LOCALE_MESSAGES';
const SET_SUPPORTED_LOCALES = 'intl/SET_SUPPORTED_LOCALES';
const APPEND_LOCALE_MESSAGES = 'intl/APPEND_LOCALE_MESSAGES';

export default {
  LOAD_LOCALE,
  SET_LOCALE_MESSAGES,
  APPEND_LOCALE_MESSAGES,
  SET_SUPPORTED_LOCALES
};
